export default {"src":"/_next/static/media/lineGroupY.08680e7e.svg","height":348,"width":1756,"blurWidth":0,"blurHeight":0};